import { render, staticRenderFns } from "./AttributeDefinitionTemplateView.vue?vue&type=template&id=87002cfc&lang=pug&"
import script from "./AttributeDefinitionTemplateView.vue?vue&type=script&lang=ts&"
export * from "./AttributeDefinitionTemplateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports